import React from "react";
import { Checkbox, Row, Col, Form } from "antd";

interface props {
  activeQuestion: any;
  discardProducts: any;
}

const MultiSelectCheckboxGroup: React.FC<props> = (props) => {
  const { activeQuestion, discardProducts } = props;
  const optionLabels = [
    "Too Expensive",
    "Not Satisfied",
    "Finished",
    "Bored! Try New",
  ];
  if (discardProducts.length === 0) {
    return <></>;
  }

  return (
    <div className="input-checkbox-group">
      <div className="input-checkbox-group__row input-checkbox-group__row--sticky">
        <div className="input-checkbox-group__col input-checkbox-group__col--product">
          <div className="label label--product">Products</div>
        </div>
        <Row className="input-checkbox-group__col">
          {optionLabels?.map((label: any, index: any) => {
            return (
              <Col span={6} key={index}>
                <div className="label label--options">{label}</div>
              </Col>
            );
          })}
        </Row>
      </div>
      {discardProducts?.map((product: any, index: number) => {
        const partsOfProduct = product?.split("-+");
        const productName = partsOfProduct[0];
        const brandName = partsOfProduct[2];
        const withBrandName = partsOfProduct[0];
        const stringWithoutLastPart = withBrandName;
        return product ? (
          <div
            className="input-checkbox-group__row input-checkbox-group__wrapper"
            key={`${product}-${index}`}
          >
            <div className="input-checkbox-group__col input-checkbox-group__col--product">
              <div className="product-item">
                {brandName && (
                  <span className="ant-checkbox brand-bold">
                    {brandName}&nbsp;-&nbsp;
                  </span>
                )}
                <span className="brand-normal">{stringWithoutLastPart}</span>
              </div>
            </div>
            <div className="input-checkbox-group__col">
              <Form.Item
                name={`notLikeP-+-${productName}`}
                rules={[
                  {
                    required: true,
                    message: "You have to choose atleast one option",
                  },
                ]}
              >
                <Checkbox.Group style={{ width: "100%" }}>
                  <Row>
                    {activeQuestion?.options?.map((option: any, index: any) => {
                      return (
                        <Col span={6} key={`${option}-${index}`}>
                          <Checkbox value={option}></Checkbox>
                        </Col>
                      );
                    })}
                  </Row>
                </Checkbox.Group>
              </Form.Item>
            </div>
          </div>
        ) : null;
      })}
    </div>
  );
};

export default MultiSelectCheckboxGroup;
